import { PanelComercialesState } from './panel_comerciales.types';
import { currentPeriod } from './api';

export const initialPanelComerciales: PanelComercialesState = {
    snapshot: {
        meta: {
            period: currentPeriod(),
            scoringCalculatedAt: null,
            flowTypes: [],
        },
        teams: [],
        commercials: [],
        vips: [],
        notifications: [],
        auditLog: [],
    },
    loading: false,
    saving: false,
    error: null,
};
